import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useParams, Link } from 'react-router-dom';
import { Schedule, Article, Build, ArrowBack } from '@mui/icons-material';
import { blogPosts } from '../../Data/blogPosts';

const PageContainer = styled.div`
  padding-top: 0;
  min-height: 100vh;
`;

const Hero = styled.div`
  background: linear-gradient(150deg, #ff80b5 0%, #9089fc 100%);
  padding: 16rem 2rem 8rem 2rem;
  margin-top: -80px;
  color: white;
  text-align: center;
  position: relative;
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 4rem 2rem;
`;

const BlogMeta = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  color: rgba(255, 255, 255, 0.9);
  margin-top: 2rem;
`;

const BlogImage = styled.div`
  margin: -100px auto 2rem;
  max-width: 1000px;
  padding: 0 2rem;
  position: relative;
  z-index: 10;

  img {
    width: 100%;
    height: 400px;
    object-fit: cover;
    border-radius: 12px;
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
  }
`;

const BlogContent = styled.div`
  font-size: 1.125rem;
  line-height: 1.8;
  color: #4b5563;

  h2 {
    font-size: 2rem;
    margin: 2rem 0 1rem;
    color: #1f2937;
  }

  h3 {
    font-size: 1.5rem;
    margin: 1.5rem 0 1rem;
    color: #374151;
  }

  p {
    margin-bottom: 1.5rem;
  }
`;

const BackButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #4f46e5;
  text-decoration: none;
  margin-bottom: 2rem;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
`;

const BlogPost = () => {
  const { slug } = useParams();
  const post = blogPosts.find(post => post.slug === slug);

  if (!post) return <div>Blog post not found</div>;

  return (
    <PageContainer>
      <Hero>
        <motion.h1>{post.title}</motion.h1>
        <BlogMeta>
          <span><Schedule /> {post.date}</span>
          <span><Article /> {post.readTime}</span>
          <span><Build /> {post.category}</span>
        </BlogMeta>
      </Hero>
      
      <BlogImage>
        <img src={post.image} alt={post.title} />
      </BlogImage>
      
      <Content>
        <BackButton to="/resources/blog">
          <ArrowBack /> Back to Blog
        </BackButton>
        <BlogContent dangerouslySetInnerHTML={{ __html: post.content }} />
      </Content>
    </PageContainer>
  );
};

export default BlogPost;